// 模板 15：企业品牌与数字营销服务机构官网

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '整合品牌与数字营销服务',
        content:
          '从品牌定位到传播执行，为企业提供一站式营销支持。'
      },
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '数据驱动的营销策略',
        content:
          '用数据评估营销效果，持续优化投放与内容。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '营销数据分析与洞察',
      subtitle: '/ Marketing Analytics',
      paragraphs: [
        '整合多渠道投放与行为数据，帮助品牌全面了解投放效果。',
        '通过可视化报表与洞察报告，为下一阶段策略提供参考。'
      ],
      buttonText: '预约方案沟通'
    },
    contact: {
      title: '成长型品牌的长期合作伙伴',
      subTitle: '用创意与数据为品牌带来持续增长',
      buttonText: '联系我们'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '新识品牌营销顾问有限公司',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__是一家专注服务 B2B 与新消费品牌的营销服务机构，提供品牌策略、创意内容与数字化运营服务。',
      '我们相信，清晰的品牌定位加上可量化的营销执行，才能帮助客户在激烈竞争中脱颖而出。'
    ]
  },
  news: [
    {
      id: 'MKT01',
      title: '助力某制造企业完成品牌升级',
      introduce:
        '通过品牌重塑与官网改版，帮助客户树立更加清晰的品牌形象。',
      date: '02-28',
      year: '2024'
    },
    {
      id: 'MKT02',
      title: '数字营销年度报告发布',
      introduce:
        '围绕热门渠道与营销玩法，总结一年来的趋势与变化。',
      date: '11-30',
      year: '2023'
    },
    {
      id: 'MKT03',
      title: '举办品牌增长闭门沙龙',
      introduce:
        '邀请多位品牌负责人分享增长案例与实践经验。',
      date: '07-03',
      year: '2023'
    },
    {
      id: 'MKT04',
      title: '自研营销数据看板工具上线',
      introduce:
        '为客户提供投放结果的一站式数据查看入口。',
      date: '03-18',
      year: '2023'
    },
    {
      id: 'MKT05',
      title: '加入行业营销服务联盟',
      introduce:
        '与多家机构共同倡导透明、可量化的营销服务体系。',
      date: '09-09',
      year: '2022'
    }
  ],
  software: {
    smartTown: {
      title: '品牌资产与内容管理平台',
      sections: [
        {
          heading: '1. 品牌资产库',
          content:
            '集中管理品牌视觉、文案与素材，保障多渠道统一性。'
        },
        {
          heading: '2. 内容排期与协同',
          content:
            '支持对多渠道内容进行排期与协作编辑，提升团队效率。'
        },
        {
          heading: '3. 活动管理',
          content:
            '记录每次营销活动的目标、执行与结果，便于沉淀经验。'
        },
        {
          heading: '4. 客户项目空间',
          content:
            '为每位客户建立独立项目空间，便于项目推进管理。'
        }
      ]
    },
    bigData: {
      title: '营销数据看板工具',
      sections: [
        {
          heading: '1. 渠道效果对比',
          desc:
            '对比不同渠道的曝光、点击与转化指标。'
        },
        {
          heading: '2. 活动 ROI 评估',
          desc:
            '从投入与产出角度评估活动效果。'
        },
        {
          heading: '3. 受众画像分析',
          desc:
            '分析触达与转化人群特征，优化后续投放策略。'
        },
        {
          heading: '4. 报告导出',
          desc:
            '支持一键导出数据报告，方便向团队或客户汇报。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '品牌策略咨询',
      engTitle: 'Brand Strategy',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '创意内容与设计',
      engTitle: 'Creative Studio',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '数字营销投放',
      engTitle: 'Digital Campaign',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '数据分析与优化',
      engTitle: 'Data-driven Optimization',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '品牌策划经理',
    responsibilities: [
      '负责客户品牌策略与传播方案的策划与撰写；',
      '与创意与设计团队紧密配合，确保方案落地效果；',
      '跟踪项目执行结果，沉淀可复用方法论。'
    ],
    requirements: [
      '有品牌策划或广告公司相关经验；',
      '文字表达与逻辑能力优秀；',
      '对品牌与设计有审美与洞察。'
    ],
    buttonText: '投递作品与简历'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-15.js